"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleSelect = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SingleSelect = function SingleSelect() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.172 1.172C0 2.343 0 4.229 0 8v8c0 3.771 0 5.657 1.172 6.828C2.343 24 4.229 24 8 24h8c3.771 0 5.657 0 6.828-1.172C24 21.657 24 19.771 24 16V8c0-3.771 0-5.657-1.172-6.828C21.657 0 19.771 0 16 0H8C4.229 0 2.343 0 1.172 1.172zM18.41 9.49a1.556 1.556 0 000-2.182 1.51 1.51 0 00-2.155 0l-6.034 6.11-2.478-2.51a1.51 1.51 0 00-2.155 0 1.557 1.557 0 000 2.182l3.556 3.6a1.51 1.51 0 002.155 0l7.11-7.2z",
    clipRule: "evenodd"
  });
};

exports.SingleSelect = SingleSelect;